import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { COLORS, FONTS } from '../constants/config';
import { shadows } from '../utils/styles';
import { useTheme } from '../contexts/ThemeContext';

import { tokens } from '@design';
import { getTextAlign } from '../utils/rtl';
interface StatCardProps {
  title: string;
  value: number | string;
  icon: keyof typeof Ionicons.glyphMap;
  color?: string;
  onPress?: () => void;
  subtitle?: string;
}

export default function StatCard({
  title,
  value,
  icon,
  color = COLORS.primary,
  onPress,
  subtitle,
}: StatCardProps) {
  const { colors } = useTheme();
  const Container = onPress ? TouchableOpacity : View;

  return (
    <Container
      style={[styles.card, { backgroundColor: colors.card, borderColor: colors.cardBorder, borderWidth: tokens.spacing.absolute["px"] }]}
      onPress={onPress}
      activeOpacity={0.7}
    >
      <View style={[styles.iconContainer, { backgroundColor: color + '20' }]}>
        <Ionicons name={icon} size={28} color={color} />
      </View>
      <View style={styles.content}>
        <Text style={[styles.value, { color: colors.textPrimary }]}>{value}</Text>
        <Text style={[styles.title, { color: colors.textMuted }]}>{title}</Text>
        {subtitle && <Text style={[styles.subtitle, { color: colors.textMuted }]}>{subtitle}</Text>}
      </View>
    </Container>
  );
}

const getStyles = (isRTL: boolean) => StyleSheet.create({
  card: {
    backgroundColor: COLORS.card,
    borderRadius: tokens.radii.absolute["radius-12"],
    padding: tokens.spacing.absolute["4"],
    flexDirection: 'row-reverse',
    alignItems: 'center',
    ...shadows.sm,
    flex: 1,
    margin: tokens.spacing.absolute["1"],
  },
  iconContainer: {
    width: 56,
    height: 56,
    borderRadius: tokens.radii.absolute["radius-12"],
    justifyContent: 'center',
    alignItems: 'center',
    marginStart: tokens.spacing.absolute["3"],
  },
  content: {
    flex: 1,
    alignItems: 'flex-end',
  },
  value: {
    fontSize: tokens.typography["heading 3"]["font size"],
    fontWeight: 'bold',
    fontFamily: FONTS.numbers,
    color: COLORS.text,
  },
  title: {
    fontSize: tokens.typography.paragraph["paragraph small font size"],
    color: COLORS.textMuted,
    marginTop: tokens.spacing.absolute["1"],
    textAlign: getTextAlign(isRTL),
  },
  subtitle: {
    fontSize: tokens.typography.paragraph["paragraph mini font size"],
    color: COLORS.textLight,
    marginTop: tokens.spacing.absolute["0_5"],
    textAlign: getTextAlign(isRTL),
  },
});

const styles = getStyles(true);
